module.exports = __webpack_public_path__ + "static/media/cleanvertising-black.d9931469.woff";